import __request__ from "routing/request";
export function postACS(requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.security/saml/acs", null, {}, {
    "Accept": []
  }, requestOptions);
}
export function getACS(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.security/saml/acs", null, {}, {
    "Accept": []
  }, requestOptions);
}
export function initiateLogin(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.security/saml/login", null, {}, {
    "Accept": []
  }, requestOptions);
}
export function getLogout(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.security/saml/logout", null, {}, {
    "Accept": []
  }, requestOptions);
}
export function postLogout(requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.security/saml/logout", null, {}, {
    "Accept": []
  }, requestOptions);
}
